import _ from 'lodash';

const buildKeysObject = <T extends Record<string, unknown>>(object: T): Record<keyof T, keyof T> =>
  _(object)
    .keys()
    .reduce((result, value) => ({ ...result, [value]: value }), {} as Record<keyof T, keyof T>);

export default buildKeysObject;
